module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-00.1.f7bf3c69.jpg";